import {Component} from '@angular/core';

@Component({
    selector: 'kan-users-admin',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanUsersAdmin {
    public selectedTab: number;

    constructor() {

    }

    ngOnInit(): void {
        this.selectedTab = 0;
    }

    public tabChanged(index: number): void {
        this.selectedTab = index;
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/users/component.ts